module.exports = __webpack_public_path__ + "img/icon_good.e68706c9.png";